import Util from '../Util';

class KioskVersionSet {
  constructor(obj = {}) {
    this.name = obj.name;
    this.printapi = obj.printapi;
    this.payapi = obj.payapi;
    this.capui = obj.capui;
    this.kskapi = obj.kskapi;
    this.cafeapi = obj.cafeapi;
    this.linuxdash = obj.linuxdash;
    this.heatwave = obj.heatwave;
    this.cortexagent = obj.cortexagent;
    // this.netd = obj.netd;
    // this.smtkms = obj.smtkms;
    this.kioskprobe = obj.kioskprobe;
    this.ciscoamp = obj.ciscoamp;
    this.reason = obj.reason;
    this.lastUpdated = obj.lastUpdated;
    this.updatedBy = obj.updatedBy;

    // extra
    this.lastUpdatedDateTime = Util.localDateTimeString(obj.lastUpdated);
    this.lastUpdatedXAgo = 'unknown';
    if (obj.lastUpdated) {
      this.lastUpdatedXAgo = Util.xUnitsOfTimeAgo(obj.lastUpdated);
    }
    if (/@/.test(obj.updatedBy)) {
      this.updatedByName = obj.updatedBy.split('@')[0];
    }
  }

  toPlainObject() {
    let obj = {};
    let keys = Object.keys(this);
    for (let k of keys) {
      switch (k) {
        // don't include these keys
        case 'lastUpdatedDateTime':
        case 'lastUpdatedXAgo':
        case 'updatedByName':
          break;
        default:
          obj[k] = this[k];
      }
    }
    return obj;
  }
}

export default KioskVersionSet;



// WEBPACK FOOTER //
// ./src/model/KioskVersionSet.js